export const V5_SIGNUP_PAGE = 'onboarding/V5_SIGNUP_PAGE'
export const V5_EMAIL_PAGE = 'onboarding/V5_EMAIL_PAGE'
export const V5_USER_PAGE = 'onboarding/V5_USER_PAGE'
export const V5_COMPANY_PAGE = 'onboarding/V5_COMPANY_PAGE'
export const V5_VERIFICATION_PAGE = 'onboarding/V5_VERIFICATION_PAGE'
